import API_BASE from './api.js';
import { validateWebImageFile } from './imageUpload.js';

function createClientId() {
  return `upload-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

async function parseJson(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.error || 'Request failed');
  }
  return data;
}

export async function uploadSupportImages(files) {
  const fileList = Array.from(files || []);
  const uploads = [];
  const token = localStorage.getItem('idToken');

  for (const file of fileList) {
    const validation = validateWebImageFile(file);
    if (!validation.ok) {
      throw new Error(validation.error);
    }

    const signRes = await fetch(
      `${API_BASE}/api/upload/presigned-url?filename=${encodeURIComponent(
        file.name
      )}&type=${encodeURIComponent(validation.mime)}&size=${encodeURIComponent(file.size)}`,
      {
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      }
    );
    const sign = await parseJson(signRes);
    const uploadUrl = sign.uploadUrl || sign.url || sign.presignedUrl;
    const fileUrl = sign.fileUrl || sign.publicUrl;

    if (!uploadUrl || !fileUrl) {
      throw new Error('Invalid upload response');
    }

    const putRes = await fetch(uploadUrl, {
      method: 'PUT',
      headers: { 'Content-Type': validation.mime },
      body: file,
    });

    if (!putRes.ok) {
      throw new Error(`Failed to upload ${file.name}`);
    }

    uploads.push({
      id: createClientId(),
      name: file.name,
      url: fileUrl,
      type: validation.mime,
      size: file.size,
    });
  }

  return uploads;
}

export async function fetchMySupportConversation() {
  const res = await fetch(`${API_BASE}/api/support-chat/mine`, {
    credentials: 'include',
  });
  return parseJson(res);
}

export async function sendMySupportMessage(payload) {
  const res = await fetch(`${API_BASE}/api/support-chat/mine/messages`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return parseJson(res);
}

export async function fetchAdminSupportConversations() {
  const res = await fetch(`${API_BASE}/api/support-chat/admin/conversations`, {
    credentials: 'include',
  });
  return parseJson(res);
}

export async function fetchAdminSupportConversation(userId) {
  const res = await fetch(`${API_BASE}/api/support-chat/admin/conversations/${userId}`, {
    credentials: 'include',
  });
  return parseJson(res);
}

export async function sendAdminSupportMessage(userId, payload) {
  const res = await fetch(`${API_BASE}/api/support-chat/admin/conversations/${userId}/messages`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return parseJson(res);
}
